<template>
  <div class="hotTopic">
    <el-row style="margin-bottom:16px;">
      <span style="font-size:22px">
        <h3 style="float:left"><i>|</i></h3>
        {{
          isGaonS ? (isEnglish ? "Hot Topic" : "热门专题") : "热门专题"
        }}</span
      >
      <a @click="findmore" style="cursor:pointer">{{
        isGaonS ? (isEnglish ? "More" : "查看更多") : "查看更多"
      }}</a>
    </el-row>
    <el-row>
      <!-- 此处为高能所改变了item.title -->
      <el-col v-for="item in hot.list" :span="6" :key="item.id + ''">
        <a :href="item.link_url">
          <!-- @click="intoSpecial(item,index)" -->
          <div class="hotpic-imgcon">
            <img
              :src="item.photo1"
              :alt="
                isGaonS
                  ? isEnglish && (item.title || '').indexOf('*##*') != -1
                    ? (item.title || '').split('*##*')[1]
                    : (item.title || '').split('*##*')[0]
                  : item.title
              "
            />
            <i
              v-text="
                isGaonS
                  ? isEnglish && (item.title || '').indexOf('*##*') != -1
                    ? (item.title || '').split('*##*')[1]
                    : (item.title || '').split('*##*')[0]
                  : item.title
              "
            ></i>
          </div>
        </a>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    hot: {
      type: Object,
      default() {
        return {
          id: "",
          list: [{ photo1: "", title: "" }]
        };
      }
    }
  },
  computed: {
    ...mapGetters(["isGaonS", "isEnglish"])
  },
  methods: {
    intoSpecial(item, index) {
      // 跳往大图
      this.$router.push({
        path: item.link_url
        // query: {
        //   type: 0,
        //   text: "",
        //   group_id: item.group_id
        // }
      });
    },
    findmore() {
      this.$router.push({ path: "/special" });
    }
  }
};
</script>
<style lang="less" scoped>
.hotTopic {
  width: 100%;
  height: 100%;

  .hotpic-imgcon {
    position: relative;
    i {
      position: absolute;
      bottom: 1px;
    }
  }

  .el-row:nth-child(1) {
    position: relative;
    span {
      font-size: 24px;
      margin-bottom: 20px;
      color: #333333;
      i {
        color: #f84949;
        margin-right: 8px;
      }
    }
    a {
      position: absolute;
      top: 10px;
      right: 0;
      color: #939393;
      font-size: 14px;
    }
    a:hover {
      color: red;
    }
  }
  .el-row:nth-child(2) {
    display: flex;
    .el-col {
      flex: 1 1 auto;
      // height: 240px;
      height: auto;
      margin-right: 10px;
      position: relative;
      &:last-child {
        margin-right: 0px;
      }
      span {
        cursor: pointer;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      i {
        width: 100%;
        height: 42px;
        background-color: rgba(0, 0, 0, 0.1);
        position: absolute;
        bottom: 5px;
        left: 0;
        box-sizing: border-box;
        padding: 15px;
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hotTopic.vue